import type { UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import {
	type AuthenticateRequest,
	type AuthenticateResponse,
	doAuthenticate,
	type PythonRequestError,
} from '../api/authenticate';

/**
 * Returns a mutation that calls the token endpoint. Pass tokenUrl from app env (e.g. AUTH_TOKEN_URL).
 * Use the same options as useMutation for onSuccess, onError, etc.
 */
export function useAuthenticateMutation(
	tokenUrl: string,
	options?: UseMutationOptions<AuthenticateResponse, PythonRequestError, AuthenticateRequest>
): UseMutationResult<AuthenticateResponse, PythonRequestError, AuthenticateRequest, unknown> {
	return useMutation<AuthenticateResponse, PythonRequestError, AuthenticateRequest, unknown>({
		mutationKey: ['auth-authenticate', tokenUrl],
		mutationFn: (params) => doAuthenticate(tokenUrl, params),
		...options,
	});
}
